module.exports = __webpack_public_path__ + "images/banner-sichuan.jpg?24485a07cd6a4ce3f8e36ec403bba46d";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/banner-sichuan.jpg
// module id = 174
// module chunks = 1